import script from "./IonicIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./IonicIcon.vue?vue&type=script&setup=true&lang=ts"

import "./IonicIcon.vue?vue&type=style&index=0&id=1788d7e3&scoped=true&lang=scss"

import exportComponent from "/home/deployer/pwa/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1788d7e3"]])

export default __exports__